module.exports = __webpack_public_path__ + "media/homepage/mariah-siner-6e7e283a.webp";